export default class ChangeComponentNodeConst {
    static VAR_ATTR_IN='variableComponentParametersInput';
    static VAR_EVENT_IN='variableComponentEventsInput';    
    static VAR_COMP_IN='variableComponentInput';
    
  }

